function getCoordToIndex(width) {
  return function coordToIndex(x, y) {
    return y * width + x;
  };
}
export {
  getCoordToIndex
};
//# sourceMappingURL=getCoordToIndex.js.map
